import React from 'react';

const ProgramTextSection = ({ title, body }) => {
  if (!body) return null;
  return (
    <section className="program-detail__text-section">
      <h2 className="program-detail__text-title">{title}</h2>
      <p className="program-detail__text-body">{body}</p>
    </section>
  );
};

export default ProgramTextSection;
